const getInitialState = () => ({
	contextId:   null,
	contextName: null,
});

export default {
	namespaced: true,
	state:      getInitialState,
	mutations:  {
		setContextId(state, value) {
			state.contextId = value;
		},
		setContextName(state, value) {
			state.contextName = value;
		},
	},
	actions: {
		setContextId:   ({ commit }, value) => commit('setContextId', value),
		setContextName: ({ commit }, value) => commit('setContextName', value),
	},
	getters: {
		contextId:   (state) => state.contextId,
		contextName: (state) => state.contextName,
	},
};
